import styled from 'styled-components'

export const StyledNewsExportPdfButton = styled.div``
